var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadEmojiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM16.0341 14.4645C14.0815 12.5118 10.9157 12.5118 8.96306 14.4645C8.57254 14.855 8.57254 15.4882 8.96306 15.8787C9.35358 16.2692 9.98675 16.2692 10.3773 15.8787C11.5488 14.7071 13.4483 14.7071 14.6199 15.8787C15.0104 16.2692 15.6436 16.2692 16.0341 15.8787C16.4247 15.4882 16.4247 14.855 16.0341 14.4645ZM11 9.5C11 10.3284 10.4404 11 9.75 11C9.05964 11 8.5 10.3284 8.5 9.5C8.5 8.67157 9.05964 8 9.75 8C10.4404 8 11 8.67157 11 9.5ZM15.25 11C15.9404 11 16.5 10.3284 16.5 9.5C16.5 8.67157 15.9404 8 15.25 8C14.5596 8 14 8.67157 14 9.5C14 10.3284 14.5596 11 15.25 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmojiIcon);
export default __webpack_public_path__ + "static/media/sad-emoji-icon.26808e27564548d6ce49dc1d9870d99e.svg";
export { ForwardRef as ReactComponent };